import {
  faFilePdf,
  faFileExcel,
  faFileWord,
  faFilePowerpoint,
  faFile,
} from '@fortawesome/free-solid-svg-icons';

export const getFileIcon = (type) => {
  switch (type?.toLowerCase()) {
    case 'pdf':
      return faFilePdf;
    case 'xlsx':
    case 'xls':
    case 'csv':
      return faFileExcel;
    case 'doc':
    case 'docx':
      return faFileWord;
    case 'ppt':
    case 'pptx':
      return faFilePowerpoint;
    default:
      return faFile;
  }
};

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
